import { Box, Chip, makeStyles } from '@material-ui/core';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
    marginTop: theme.spacing(2),
    justifyContent: 'center',
    alignItems: 'center',
  },
  label: {
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
    marginRight: theme.spacing(1),
  },
  chip: {
    backgroundColor: 'transparent',
    borderColor: theme.palette.divider,
    color: theme.palette.text.secondary,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main,
    },
    '& .MuiChip-icon': {
      color: 'inherit',
    },
  },
}));

interface BackstageAgentSuggestedQuestionsProps {
  onQuestionClick: (question: string) => void;
}

const SUGGESTED_QUESTIONS = [
  'Who owns component:default/backstage?',
  'What is the scorecard for component:default/backstage?',
  'What can you do?',
];

export const BackstageAgentSuggestedQuestions = ({
  onQuestionClick,
}: BackstageAgentSuggestedQuestionsProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <span className={classes.label}>Try asking:</span>
      {SUGGESTED_QUESTIONS.map(question => (
        <Chip
          key={question}
          label={question}
          variant="outlined"
          size="small"
          className={classes.chip}
          icon={<HelpOutlineIcon />}
          onClick={() => onQuestionClick(question)}
        />
      ))}
    </Box>
  );
};
